import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FpFooterComponent } from './common/fp-footer/fp-footer.component';
import { FpNavbarComponent } from './common/fp-navbar/fp-navbar.component';
import { ToggleService } from '../../../shared/component/header/toggle.service';

interface Particle {
  left: string;
  size: string;
  duration: string;
  delay: string;
  radius: string;
  color: string;
}

@Component({
    selector: 'app-front-pages',
    imports: [ FpFooterComponent, FpNavbarComponent, RouterOutlet  ],
    templateUrl: './front-pages.component.html',
    styleUrl: './front-pages.component.scss',
    standalone: true
})
export class FrontPagesComponent {

  generateParticles(count: number): Particle[] {
  return Array.from({ length: count }).map(() => ({
    left: `${75 + Math.random() * 20}%`, // côté droit
    size: `${Math.random() * 5 + 2}px`,
    duration: `${Math.random() * 8 + 6}s`,
    delay: `${Math.random() * 10}s`,
    radius: `${Math.random() * 120 + 40}px`,
    color: ['bg-primary-500','bg-secondary-800','bg-secondary-500','bg-gray-700'][Math.floor(Math.random()*3)]
  }));
}

particleLayers = [
  this.generateParticles(40),
  // this.generateParticles(30),
  // this.generateParticles(20),
  this.generateParticles(80)
];

    constructor(
        public toggleService: ToggleService
    ) {}

    ngOnInit(): void {
        // Initialize theme and direction on component load
        this.toggleService.initializeTheme();
    }

    // Toggle theme between light and dark
    toggleTheme() {
        this.toggleService.toggleTheme();
    }

    // Toggle direction between LTR and RTL
    toggleDirection() {
        this.toggleService.toggleDirection();
    }

}
